import React, { Dispatch } from 'react';
import { IScenario } from '../interfaces';
import '../App.css';
import { Box } from './Box'

interface InjectNodeMenuProps {
    updateShowHide: Dispatch<any>;
    showNodeInjMenu: string;
    clickManageTimeline: Dispatch<any>;
    selectedScenario: IScenario;
  }

const InjectNodeMenu: React.FC<InjectNodeMenuProps> = ({ updateShowHide, showNodeInjMenu, clickManageTimeline, selectedScenario }) => {

    const backToTimeline = (ev: React.MouseEvent<HTMLElement>) => {
        clickManageTimeline({});
    }

    return (
        <div className={`inject-node-menu ${showNodeInjMenu}`}>
            { selectedScenario.published ? <div className="inject-node-menu-unpublished"></div> : <></> }
            <div className="turn-label" style={{margin: '0.5em 10px 0.5em'}}>Nodes</div>
            <Box name="inject-node" title="Inject Node" type="inject" />
            <Box name="inject-end-node" title="Inject End Node" type="injectEnd" />
            <div className="turn-label" style={{margin: '1em 10px 0.5em'}}>Node Modules</div>
            <Box name="coa" title="Courses of Action" type="coa" />
            <Box name="rfi" title="Request For Information" type="rfi" />
            <Box name="info" title="Information Brief" type="info" />
            <Box name="ttl" title="No Action Taken" type="ttl" />

            <div className="inject-box inject-box-back" onClick={backToTimeline}>
                <div className={`back`}>
                    <div className={`back-svg menu-svg`}>
                        <img src="/img/chevron-right-white.svg" className="back-img" alt="" />
                    </div>
                    <div className="item-text">Back To Timeline</div>
                </div>
            </div>
        </div> 
    )
}

export default InjectNodeMenu;